module.exports = {
  ageGroups: require('./lib/age-groups'),
  certifications: require('./lib/certifications'),
  communities: require('./lib/communities'),
  degrees: require('./lib/degrees'),
  faiths: require('./lib/faiths'),
  fieldsOfStudy: require('./lib/fields-of-study'),
  genders: require('./lib/genders'),
  insuranceProviders: require('./lib/insurance-providers'),
  languages: require('./lib/languages'),
  professions: require('./lib/professions'),
  professionalAffiliations: require('./lib/professional-affiliations'),
  pronouns: require('./lib/pronouns'),
  raceEthnicities: require('./lib/race-ethnicities'),
  services: require('./lib/services'),
  serviceDefinitions: require('./lib/service-definitions'),
  specialties: require('./lib/specialties'),
  treatmentTypes: require('./lib/treatment-types'),
};
